export default __webpack_public_path__ + "static/media/airstrapz-bpk-3.50ff4088.png";